<template>
  <div class="pay-wrap" v-loading="loading" element-loading-text="支付提交中..."
    element-loading-background="rgba(0, 0, 0, 0)">
    <div class="pay-order-detail">
      <base-tag label="服务单明细"></base-tag>
      <div class="pay-detail-tag">
        <div class="detail-item-no">服务单编号</div>
        <div class="detail-item item-center">患者名称</div>
        <div class="detail-item item-center">服务单类型</div>
        <!-- <div class="detail-item item-right">金额 * 数量</div> -->
        <div class="detail-item item-right">加急费</div>
        <div class="detail-item item-right">总 价</div>
      </div>
      <div class="pay-detail-item" v-for="(item,i) in orderPayDetail.orderList" :key="i">
        <div class="detail-item-no">{{item.servOrderNo}}</div>
        <div class="detail-item item-center">{{item.demPatient}}</div>
        <div class="detail-item item-center">
          <serv-tag :code="item.servCataId" />
        </div>
        <!-- <div class="detail-item item-right">¥ {{parseMoney(item.orderPrice)}} * {{item.orderCount}}</div> -->
        <div class="detail-item item-right">¥ {{parseMoney(item.orderRushFee)}}</div>
        <div class="detail-item item-right">¥ {{parseMoney(item.orderAmount)}}</div>
      </div>

      <div class="pay-detail-total">
        <div class="detail-total item-right">合 计</div>
        <div class="detail-item item-right">¥ {{parseMoney(totalPrice)}}
        </div>
      </div>
    </div>
    <!--支付方式-->
    <div class="pay-order-type">
      <base-tag label="支付方式"></base-tag>
      <div class="pay-type-item">
        <div :class="{active:payType=='00'}" @click="changePayType('00')"><img src="/static/images/pay/wallet.png"
            alt=""></div>
        <div :class="{active:payType=='01'}" @click="changePayType('01')"><img src="/static/images/pay/alipay.png"
            alt=""></div>
        <!-- <div :class="{active:payType=='02'}" @click="changePayType('02')"><img src="/static/images/pay/wechat.png"
            alt=""></div> -->
        <div :class="{active:payType=='03'}" @click="changePayType('03')"><img src="/static/images/pay/union.png"
            alt=""></div>
      </div>
      <div class="pay-order-balance" v-if="payType == '00'">
        <base-tag label="付款信息" style="width: 100%;"></base-tag>
        <div class="pay-bank-item">
          <div class="pay-bank-label">
            账户余额：
          </div>
          <div class="pay-balace-value" :style="totalPrice > orderPayDetail.userInfo.balance ? 'color: red;' : ''">
            ¥ {{parseMoney(orderPayDetail.userInfo.balance)}}
          </div>
        </div>
        <div class="pay-bank-item">
          <div class="pay-bank-label">
            付款金额：
          </div>
          <div class="pay-balace-value">
            ¥ {{parseMoney(totalPrice)}}
          </div>
        </div>
      </div>
      <div class="pay-order-balance" v-if="payType == '01'">
        <base-tag label="付款信息" style="width: 100%;"></base-tag>
        <div class="pay-bank-item">
          <div class="pay-bank-label">
            付款金额：
          </div>
          <div class="pay-balace-value">
            ¥ {{parseMoney(totalPrice)}}
          </div>
        </div>
      </div>
      <div class="pay-order-balance" v-if="payType == '02'">
        <base-tag label="付款信息" style="width: 100%;"></base-tag>
        <div class="pay-bank-item">
          <div class="pay-bank-label">
            付款金额：
          </div>
          <div class="pay-balace-value">
            ¥ {{parseMoney(totalPrice)}}
          </div>
        </div>
      </div>
      <div class="pay-order-bank" v-if="payType == '03'">
        <base-tag label="付款信息" style="width: 100%;"></base-tag>
        <div class="pay-bank-item">
          <div class="pay-bank-label">
            收款人：
          </div>
          <div class="pay-bank-value">
            医小智（日照）工业互联网有限公司
          </div>
        </div>
        <div class="pay-bank-item">
          <div class="pay-bank-label">
            开户银行：
          </div>
          <div class="pay-bank-value">
            日照银行股份有限公司日照高新支行
          </div>
        </div>
        <div class="pay-bank-item">
          <div class="pay-bank-label">
            银行账号：
          </div>
          <div class="pay-bank-value">
            810101001421082775
          </div>
        </div>
        <div class="pay-bank-item">
          <div class="pay-bank-label">
            付款金额：
          </div>
          <div class="pay-bank-value">
            ¥ {{parseMoney(totalPrice)}}
          </div>
        </div>
        <base-tag label="回执信息" style="width: 100%;"></base-tag>
        <div class="pay-bank-item">
          <div class="pay-bank-label">
            汇款账号：
          </div>
          <div class="pay-bank-value">
            <el-input class="input-form" v-model="payBankNo" size="mini" />
          </div>
        </div>
      </div>
    </div>

    <div class="pay-order-action">
      <y-button text="付款完成" :classStyle="(payBankNo.length < 12) ? 'disabled-btn ml' : 'main-btn ml'"
        @btnClick="clickFinish" v-if="payType == '03'" />
      <y-button text="立即支付"
        :classStyle="(payType == '' ||  (payType == '00' && totalPrice > orderPayDetail.userInfo.balance) ) ? 'disabled-btn ml' : 'main-btn ml'"
        @btnClick="clickSubmit" v-else />
      <y-button text="取消支付" classStyle="main-btn ml" @btnClick="clickClosePay" />
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import BaseTag from '/components/BaseTag'
  import ServTag from '/components/ServTag'
  import YButton from '/components/YButton'
  export default {
    props: {
      orderPayDetail: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        loading: false,
        payType: '',
        payBankNo: '',
        payUrl: ''
      }
    },
    computed: {
      ...mapState(['common', 'user']),
      // 计算价格
      totalPrice() {
        var totalPrice = 0
        this.orderPayDetail.orderList && this.orderPayDetail.orderList.forEach(item => {
          //正畸加收费用
          if (item.servCataId == '3010130' && item.orthodonticsData.bracesCount > 0) {
            totalPrice += item.orthodonticsData.addPrice
          } else if(item.orderStatus == '31' && item.diffAmount > 0) {
            totalPrice += item.diffAmount
          }else{
            totalPrice += item.orderAmount
          }
        })
        return totalPrice
      },
      payOrderIds() {
        var payOrderIds = []
        this.orderPayDetail.orderList && this.orderPayDetail.orderList.forEach(item => {
          payOrderIds.push(item.servOrderId)
        })
        return payOrderIds
      }
    },
    methods: {
      changePayType(type) {
        this.payType = this.payType == type ? '' : type;
      },
      clickSubmit() {
        // 支付宝提示+跳转
        if (['01','02'].includes(this.payType)) {
          this.$message({
            type: 'warning',
            // message: '支付渠道暂未开启,请选择其他支付方式!!!'
            message: '请支付宝充值后，余额支付订单'
          });
          setTimeout(() => {
            this.$router.push({
              path: '/user/money',
              query: {
                key1: '1'
              }
            });
          }, 2000);
          return;
        }
        var confirmText = "";
        switch (this.payType) {
          case '00':
          case '01':
          case '02':
            confirmText = "确定立即支付？"
            break;
          case '03':
            confirmText = "确定已完成转账？"
            break;
          default:
            break;
        }
        this.$confirm(confirmText, '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true
        }).then(() => {
          this.loading = true
          let url = '/biz/orderServ/dem/pay';
          let data = {
            servOrderIds: this.payOrderIds,
            payType: this.payType,
            payAmount: this.totalPrice,
            payBankNo: this.payBankNo
          }
          this.$api.post({
            url: url,
            data: data
          }).then(res => {
            console.log('res:', res)
            this.loading = false
            if (res.code == 200) {
              var msgTxt = "";
              switch (this.payType) {
                case "00":
                  msgTxt = "支付成功!"
                  break;
                case "01":
                  this.payUrl = res.data.payUrl;
                  document.write(this.payUrl)
                  break;
                case "02":
                  break;
                case "03":
                  msgTxt = "支付已提交，请等待客服审核!"
                  break;
                default:
                  break;
              }
              this.$message({
                type: 'success',
                message: msgTxt
              });
              this.clickClosePay();
            }
            this.loading = false
          })
        }).catch(() => {

        });

      },
      clickFinish() {
        if (this.payBankNo == '' || this.payBankNo.length < 12) {
          this.$message({
            type: 'error',
            message: '请输入【汇款账号】回执信息!!!'
          });
        }
        this.clickSubmit();
      },
      clickClosePay() {
        this.payType = '';
        this.payBankNo = '';
        this.$emit('cancelPay', event)
      }
    },
    created() {},
    mounted() {

    },
    components: {
      BaseTag,
      ServTag,
      YButton
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/style/mixin";

  .pay-wrap {}

  .pay-order-detail {
    padding-top: 10px;
  }

  .pay-detail-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 8px 20px;
  }

  .pay-detail-tag {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    border-bottom: 1px solid #E4E7ED;
  }

  .pay-detail-total {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    font-size: 16px;
    font-weight: 500;
    border-top: 1px solid #E4E7ED;
    border-bottom: 1px solid #E4E7ED;
  }

  .detail-item {
    flex: 1;
  }

  .detail-item-no {
    flex: 1.5;
  }

  .detail-total {
    flex: 5;
  }

  .item-center {
    text-align: center;
  }

  .item-right {
    text-align: right;
  }

  .pay-order-type {
    padding-top: 10px;
  }

  .pay-type-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    padding: 10px 0;

    div {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5px;
      border: 1px solid #ECECEC;
      border-radius: 5px;
      cursor: pointer;

      &.active {
        border-color: #00a5d5;
        background: #fff;
      }
    }

    img {
      width: 200px;
    }
  }

  .pay-order-balance,
  .pay-order-bank {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px 0;
    font-size: 16px;
    font-weight: 500;
  }

  .pay-bank-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 2px 0;
    width: 100%;
  }

  .pay-bank-label {
    flex: 2;
    text-align: right;
  }

  .pay-bank-value {
    flex: 3;
    padding-left: 10px;
  }

  .pay-balace-value {
    flex: 2;
    padding-left: 10px;
  }

  .pay-order-action {
    width: 100%;
    text-align: center;
    padding: 20px;
  }

  .input-form {
    width: 50%;
  }
</style>



// WEBPACK FOOTER //
// payOrder.vue?46cf632e